import { render, staticRenderFns } from "./ItemsVuetify.vue?vue&type=template&id=ac2f5c58&scoped=true"
import script from "./ItemsVuetify.vue?vue&type=script&lang=js"
export * from "./ItemsVuetify.vue?vue&type=script&lang=js"
import style0 from "./ItemsVuetify.vue?vue&type=style&index=0&id=ac2f5c58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2f5c58",
  null
  
)

export default component.exports